<template>
  <div class="internal-invoice-listing">
    <v-layout class="my-2">
      <v-flex md3>
        <DateRangePicker
          placeholder="Date Range"
          v-model="dates"
          v-on:update:model-value="getContracts()"
          v-on:click:clear="clearFilter('dates')"
          class="mr-2"
        ></DateRangePicker>
      </v-flex>
      <v-flex md3>
        <div class="d-flex">
          <v-text-field
            v-model.trim="search"
            v-on:click:clear="clearFilter('search')"
            clearable
            dense
            filled
            flat
            label="Search"
            hide-details
            solo
            :loading="contractLoading"
            :disabled="contractLoading"
            color="cyan"
            @keydown.enter="getContracts()"
            @keydown.tab="getContracts()"
          ></v-text-field>
          <v-btn
            class="mx-2 custom-bold-button white--text"
            color="cyan"
            tile
            depressed
            :disabled="contractLoading"
            v-on:click="getContracts()"
          >
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
          <v-btn
            class="mx-2 custom-bold-button white--text"
            depressed
            :disabled="contractLoading"
            v-on:click="getContracts()"
            color="cyan white--text"
            ><v-icon>mdi-reload</v-icon></v-btn
          >
        </div>
      </v-flex>
      <v-flex md1> </v-flex>
    </v-layout>
    <ListingTable :columnCount="7" :rowData="rowData">
      <template v-slot:thead>
        <thead>
          <tr>
            <th class="simple-table-th">Contract #</th>
            <th class="simple-table-th">Contract Title</th>
            <th class="simple-table-th">Customer Info</th>
            <th class="simple-table-th">Basic Detail</th>
            <th class="simple-table-th">Dates</th>
            <th class="simple-table-th">No. Of Services</th>
            <th class="simple-table-th">Status</th>
            <th class="simple-table-th">Created Time</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="rowData.length">
            <tr
              v-for="(row, index) in rowData"
              :key="index"
              v-on:click="routeToContract(row)"
              class="alternate-listing-row"
            >
              <td class="simple-table-td">
                <Barcode :barcode="row.barcode"></Barcode>
              </td>
              <td class="simple-table-td">
                <p class="m-0 custom-nowrap-ellipsis">
                  {{ row.contract_title }}
                </p>
              </td>
              <td class="simple-table-td">
                <div class="contract-listing-customer">
                  <p class="m-0 custom-nowrap-ellipsis">
                    <b>Display Name: </b>
                    <template v-if="row.customer && row.customer.display_name">
                      {{ row.customer && row.customer.display_name }}
                    </template>
                    <em v-else class="text-muted"> no display name</em>
                  </p>
                  <p class="m-0 custom-nowrap-ellipsis">
                    <b>Company: </b>
                    <template v-if="row.customer && row.customer.company_name">
                      {{ row.customer && row.customer.company_name }}
                    </template>
                    <em v-else class="text-muted"> no Company</em>
                  </p>
                  <p class="m-0 custom-nowrap-ellipsis">
                    <b>Email: </b>

                    <template
                      v-if="
                        row.property_person && row.property_person.primary_email
                      "
                    >
                      {{
                        row.property_person && row.property_person.primary_email
                      }}
                    </template>
                    <em v-else class="text-muted"> no email</em>
                  </p>
                  <p class="m-0 custom-nowrap-ellipsis">
                    <b>Phone: </b>
                    <template
                      v-if="
                        row.property_person && row.property_person.primary_phone
                      "
                    >
                      {{
                        row.property_person && row.property_person.primary_phone
                      }}
                    </template>
                    <em v-else class="text-muted"> no Phone</em>
                  </p>
                </div>
              </td>
              <td class="simple-table-td">
                <div class="contract-listing-customer">
                  <p class="m-0 custom-nowrap-ellipsis">
                    <b>Reference: </b>
                    <template v-if="row.reference">{{
                      row.reference
                    }}</template>
                    <template v-else
                      ><em class="text--secondary">No Reference</em></template
                    >
                  </p>
                  <p v-if="false" class="m-0 custom-nowrap-ellipsis">
                    <b>Sales representative: </b>
                    <template v-if="row.sales">{{ row.sales }}</template>
                    <template v-else
                      ><em class="text--secondary"
                        >No Sales representative</em
                      ></template
                    >
                  </p>
                  <p class="m-0 custom-nowrap-ellipsis">
                    <b>Prepared by: </b>
                    <template v-if="row.prepared_by">{{
                      row.prepared_by
                    }}</template>
                    <template v-else
                      ><em class="text--secondary">No Prepared by</em></template
                    >
                  </p>
                </div>
              </td>
              <td class="simple-table-td">
                <p class="m-0 custom-nowrap-ellipsis">
                  <b>Created: </b> {{ formatDate(row.date) }}
                </p>
                <p class="m-0 custom-nowrap-ellipsis">
                  <b>Start Date: </b>
                  {{ formatDate(row.contract_start) }}
                </p>
                <p class="m-0 custom-nowrap-ellipsis">
                  <b>End Date: </b>
                  {{ formatDate(row.contract_end) }}
                </p>
              </td>
              <td class="simple-table-td">
                <div class="contract-listing-customer">
                  <p class="m-1 custom-nowrap-ellipsis-count">
                    <v-badge
                      color="green"
                      :content="row.total_service"
                      class="mr-9 ml-2"
                    >
                      <!--   Item Two -->
                    </v-badge>
                    <b>Total </b>
                  </p>

                  <p class="m-1 custom-nowrap-ellipsis-count">
                    <v-badge
                      color="orange"
                      :content="row.visit_count"
                      class="mr-9 ml-2"
                    >
                    </v-badge>
                    <b>Used</b>
                  </p>
                  <p class="m-1 custom-nowrap-ellipsis-count">
                    <template v-if="getBalance(row) > 0">
                      <v-badge
                        color="red"
                        class="mr-9 ml-2"
                        :content="getBalance(row)"
                      >
                      </v-badge>
                    </template>
                    <template v-else>
                      <v-badge color="red" content="0" class="mr-9 ml-2">
                      </v-badge>
                    </template>
                    <b>Balance </b>
                  </p>
                </div>
              </td>
              <td class="simple-table-td">
                <div class="contract-listing-status">
                  <!-- <template
                    v-if="
                      row.quotation &&
                      (row.quotation.status === 2 || row.quotation.status === 3)
                    "
                  >
                    <Status small :status="row.quotation.status === 2" />
                  </template> -->
                  <template>
                    <CustomStatus
                      small
                      :status="row.status"
                      endpoint="contract/status"
                    >
                    </CustomStatus>
                  </template>
                  <div class="mb-1">
                    <template v-if="!row.is_reviewed && false">
                      <v-tooltip top content-class="custom-top-tooltip">
                        <template v-slot:activator="{ on, attrs }">
                          <v-chip
                            v-bind="attrs"
                            v-on="on"
                            color="red"
                            class="ml-0 mr-2 white--text font-weight-600"
                            label
                            small
                          >
                            Under Review
                          </v-chip>
                        </template>
                        <span>Contract is Under Review</span>
                      </v-tooltip>
                    </template>
                  </div>
                  <div class="mb-1">
                    <template v-if="row.is_revised">
                      <v-tooltip top content-class="custom-top-tooltip">
                        <template v-slot:activator="{ on, attrs }">
                          <v-chip
                            v-bind="attrs"
                            v-on="on"
                            color="red lighten-4"
                            class="mx-2 custom-status font-weight-600 custom-grey-border d-inline-table d-inline text-uppercase justify-center font-10"
                            label
                            small
                          >
                            Renewed
                          </v-chip>
                        </template>
                        <span>Contract is Renewed</span>
                      </v-tooltip>
                      <template
                        v-if="
                          row.revised_to_contract &&
                          row.revised_to_contract.barcode
                        "
                      >
                        <p>
                          <Barcode
                            route="contract.detail"
                            :barcode="row.revised_to_contract.barcode"
                            :id="row.revised_to_contract.id"
                          ></Barcode>
                        </p>
                      </template>
                    </template>
                  </div>

                  <div class="mb-1">
                    <template v-if="row.revise && row.revise.barcode">
                      <v-tooltip top content-class="custom-top-tooltip">
                        <template v-slot:activator="{ on, attrs }">
                          <Barcode
                            route="contract.detail"
                            :barcode="row.revise.barcode"
                            :id="row.revise.id"
                          ></Barcode>
                        </template>
                        <span
                          >Contract is Renewed from
                          {{ row.revise.barcode }}</span
                        >
                      </v-tooltip>
                    </template>
                  </div>
                </div>
              </td>
              <td class="simple-table-td">
                <TableActivity v-if="!lodash.isEmpty(row.added_by)" :data="row">
                  <template v-slot:first_letters>
                      {{ getFirstLetters(row.added_by?.display_name) }}
                  </template>
                  <template v-slot:display_name>
                    {{ row.added_by.display_name }}
                  </template>
                  <template v-slot:date_time>
                    {{ row.created_at }}
                  </template>
                  <template v-slot:format_date_time>
                    {{ formatDateTime(row.added_at) }}
                  </template>
                </TableActivity>
              </td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td colspan="7">
                <p
                  class="m-0 row-not-found text-center font-weight-500 font-size-16"
                >
                  <img
                    :src="$assetURL('media/error/empty.png')"
                    class="row-not-found-image"
                  />
                  Uhh... There are no contracts at the moment.
                </p>
              </td>
            </tr>
          </template>
        </tbody>
      </template>
    </ListingTable>
    <ListingFooter
      v-if="totalRows>0"
      :dataLoading="contractLoading"
      :showingFrom="showingFrom"
      :showingTo="showingTo"
      :totalRows="totalRows"
      :currentPage="currentPage"
      :totalPages="totalPages"
    ></ListingFooter>
  </div>
</template>

<script>
import Barcode from "@/view/pages/partials/Barcode.vue";
import CommonMixin from "@/core/plugins/common-mixin";
import ListingTable from "@/view/pages/partials/Listing-Table.vue";
import ListingFooter from "@/view/pages/partials/Listing-Footer.vue";
import { QUERY } from "@/core/services/store/request.module";
import CustomStatus from "@/view/pages/partials/CustomStatus.vue";
import TableActivity from "@/view/pages/partials/Table-Activity.vue";
import DateRangePicker from "@/view/components/DateRangePicker";
// import Status from "@/view/pages/partials/Status.vue";

export default {
  mixins: [CommonMixin],
  data() {
    return {
      contractLoading: false,
      rowData: [],
      dates: [],
      currentPage: 1,
      status: "all",
      search: null,
      totalPages: 0,
      totalRows: 0,
      rowsOffset: 0,
    };
  },
  props: {
    type: {
      type: String,
      default: null,
    },
    typeId: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    typeId() {
      this.$nextTick(() => {
        this.getContracts();
      });
    },
  },
  methods: {
    getBalance(row) {
      let balance = Number(row.total_service) - Number(row.visit_count);
      return Number(balance);
    },
    routeToDetailLink(id, type) {
      this.$router.push({
        name: type,
        params: { id },
      });
    },
    clearFilter(field) {
      const _this = this;
      switch (field) {
        case "search":
          _this.search = null;
          break;
        case "dates":
          _this.dates = [];
          break;
      }
      _this.getContracts();
    },
    getContracts() {
      const data = {
        current_page: this.currentPage,
        entity: 0,
        search: this.search,
        status: this.status,
        type: this.type,
        type_id: this.typeId,
        dates: this.dates,
      };

      if (this.contractLoading) {
        return false;
      }

      this.contractLoading = true;

      this.$store
        .dispatch(QUERY, { url: "contract", data: data })
        .then(({ data }) => {
          this.totalPages = Math.ceil(data.total_rows / data.per_page);
          this.currentPage = data.current_page;
          this.rowData = data.rows;
          this.totalRows = data.total_rows;
          this.rowsOffset = data.offset;
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.contractLoading = false;
        });
    },
    routeToContract(row) {
      this.$nextTick(() => {
        this.$router.push(
          this.getDefaultRoute("contract.detail", {
            params: {
              id: row.id,
            },
          })
        );
      });
    },
  },
  computed: {
    showingFrom() {
      return this.lodash.isEmpty(this.rowData) === false
        ? this.rowsOffset + 1
        : 0;
    },
    showingTo() {
      return this.rowsOffset + (this.rowData ? this.rowData.length : 0);
    },
  },
  mounted() {
    this.getContracts();
  },
  components: {
    Barcode,
    TableActivity,
    CustomStatus,
    ListingFooter,
    ListingTable,
    DateRangePicker,
    // Status,
  },
};
</script>

<style scoped>
.internal-invoice-listing ::v-deep .v-data-table__wrapper > table {
  table-layout: fixed;
}
</style>
